import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { Observable, Subject, Subscription } from 'rxjs';
import { faTrashCan, faCirclePlay, faCopy, faPlay, faPause, faMagnifyingGlassPlus, faMagnifyingGlassMinus, faRocket, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { TileItem, ITileItem } from '../../../../core/models/tile-item.model';
import { IAudioProcessorTaskBlock } from '../../../../core/models/audio-processor-task.model';
import { FormControl } from '@angular/forms';
import { concatWith, map, min, startWith, tap, throttleTime } from 'rxjs/operators';
import { IAudioPlugin, IMenuItem } from '../../../../core/models/plugin.model';
import { BroadcastService } from '../../../../core/broadcast/broadcast.service';
import { v4 as uuidv4 } from 'uuid';
import WaveSurfer from 'wavesurfer.js';
import CursorPlugin from 'wavesurfer.js/src/plugin/cursor';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AsyncAction } from 'rxjs/internal/scheduler/AsyncAction';
import { AsyncService } from '../../../../core/async/async.service';
import TimelinePlugin from 'wavesurfer.js/src/plugin/timeline';
import { TaskModel } from '../../task.model';
import MediaSessionPlugin from 'wavesurfer.js/src/plugin/mediasession';
import { AudioUtils } from '../../../../core/utils/audio.utils';

const FROM_ITEM_MENU_ID = 1;
const TO_ITEM_MENU_ID = 2;

@Component({
  selector: 'app-task-creator-tile',
  templateUrl: 'task.creator.tile.component.html',
  styleUrls: ['task.creator.tile.component.scss']
})

export class TaskCreatorTileComponent implements OnInit {

  @Output() loadBlockEvent = new EventEmitter<any>();
  @Output() previewBlockEvent = new EventEmitter<any>();
  @Output() openInfoBlockEvent = new EventEmitter<any>();
  @Output() deleteBlockEvent = new EventEmitter<any>();
  @Output() copyBlockSettingsEvent = new EventEmitter<any>();
  @Output() stopAllPlayersEvent = new EventEmitter<any>();
  @Input() block!: IAudioProcessorTaskBlock;
  @Input() plugin!: IAudioPlugin | undefined;
  faTrashCan = faTrashCan;
  faCirclePlay = faCirclePlay;
  faMagnifyingGlassPlus = faMagnifyingGlassPlus;
  faMagnifyingGlassMinus = faMagnifyingGlassMinus;
  faCopy = faCopy;
  faPlay = faPlay;
  faPause = faPause;
  faRocket = faRocket;
  faCircleInfo = faCircleInfo;
  isInError = false;
  currentPlugin: string = "";
  waveInstance!: WaveSurfer;
  wavePlugins: any = {};
  subscription!: Subscription;
  waveformId: string = "waveform-" + uuidv4();
  loaderId: string = "loader-" + uuidv4();
  timelineId: string = "timeline-" + uuidv4();
  fromDropdownInstance!: any;
  toDropdownInstance!: any;
  fromControl = new FormControl('');
  toControl = new FormControl('');
  filteredFromMenuItems!: Observable<IMenuItem[]>;
  filteredToMenuItems!: Observable<IMenuItem[]>;
  mousePosition: any = {
    left: 0,
    top: 0,
    x: 0,
    y: 0,
  };
  zoom: number = 10;
  pluginNames: any = {
    BLACK: "BLACK",
    LAVA: "LAVA",
    INFERENCE: "INFERENCE"
  };
  fromMenuItems: IMenuItem[] = [];
  toMenuItems: IMenuItem[] = [];
  resize = new Subject<void>();
  searchModeOption = 'contains';
  searchExprOption: any = 'caption';
  searchTimeoutOption = 200;
  minSearchLengthOption = 0;
  showDataBeforeSearchOption = false;
  resizeSubscription!: Subscription;
  audioBuffer!: ArrayBuffer;

  constructor(
    private broadcastService: BroadcastService,
    private loader: NgxUiLoaderService,
    private async: AsyncService,
    private taskModel: TaskModel) {
    this.subscription = this.broadcastService.getMessage().subscribe(this.onMessageReceived.bind(this));
  }

  ngOnInit() {
    const plugin = this.plugin as IAudioPlugin;
    const menuItems = Object.assign(plugin.menuItems, {});
    let from = menuItems.filter(item => { return item.menuId === FROM_ITEM_MENU_ID })[0];
    let to = menuItems.filter(item => { return item.menuId === TO_ITEM_MENU_ID })[0];
    this.block.plugin = plugin;
    this.block.pluginId = plugin.id;
    this.fromMenuItems = menuItems.filter(item => { return item.menuId === FROM_ITEM_MENU_ID })
      .sort((a: IMenuItem, b: IMenuItem) => {
        if (a.caption < b.caption) return -1;
        if (a.caption > b.caption) return 1;
        return 0;
      });
    this.toMenuItems = menuItems.filter(item => { return item.menuId === TO_ITEM_MENU_ID })
      .sort((a: IMenuItem, b: IMenuItem) => {
        if (a.caption < b.caption) return -1;
        if (a.caption > b.caption) return 1;
        return 0;
      });
    this.block.menuItems = [from, to];
    this.currentPlugin = this.block.plugin.name;
    this.resizeSubscription = this.resize.asObservable()
      .pipe(
        throttleTime(1000)
      ).subscribe(() => {
        //this.waveInstance?.destroy();
        //this.initializeWaveform();
      })
    setTimeout(() => {
      this.initializeWaveform();
    }, 1000);

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.resizeSubscription.unsubscribe();
    this.waveInstance?.stop();
    this.waveInstance?.destroy();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resize.next();
  }

  onPluginSelectionChanged(plugin: IAudioPlugin) {
    this.block.plugin = plugin;
    this.block.pluginId = plugin.id;
  }

  deleteBlockRequest($event: Event, block: IAudioProcessorTaskBlock) {
    this.deleteBlockEvent.emit(block);
    this.waveInstance?.stop();
    this.waveInstance?.destroy();
  }

  sendCopyBlockSettings(block: IAudioProcessorTaskBlock) {
    this.broadcastService.sendMessage({ type: "copy", block: block });
  }

  onMessageReceived(data: any) {
    if (data.type == "copy") {
      this.block.menuItems[0] = data.block.menuItems[0];
      this.block.menuItems[1] = data.block.menuItems[1];
    }
    if (data.type == "stop" && data.id != this.waveformId) {
      this.waveInstance?.stop();
    }
  }

  onFromValueChanged(event: any) {
    if (!event.value) {
      this.block.menuItems[0] = this.fromMenuItems[0];
    } else {
      this.block.menuItems[0] = event.value;
    }
  }

  onToValueChanged(event: any) {
    if (!event.value) {
      this.block.menuItems[1] = this.toMenuItems[0];
    } else {
      this.block.menuItems[1] = event.value;
    }
  }

  onFromDropdownInitialized(event: any) {
    this.fromDropdownInstance = event.component;
  }

  onToDropdownInitialized(event: any) {
    this.toDropdownInstance = event.component;
  }

  getPluginName(name: string) {
    return name.slice(0, -4);
  }

  getMenuItems(block: IAudioProcessorTaskBlock, menuId: number) {
    if (block.plugin && block.plugin.menuItems) {
      return block.plugin.menuItems.filter(item => { return item.menuId === menuId });
    } return [];
  }

  playPause() {
    this.broadcastService.sendMessage({ type: "stop", id: this.waveformId });
    this.waveInstance.playPause();
  }

  enableDragScroll() {
    let wave = (document.querySelector("#" + this.waveformId + " " + "wave") as HTMLElement);
    wave.style.cursor = 'grab';

    const mouseDownHandler = (e: any) => {
      if (e.ctrlKey || e.target.tagName == "polygon") return;
      this.mousePosition = {
        // The current scroll
        left: wave.scrollLeft,
        top: wave.scrollTop,
        // Get the current mouse position
        x: e.clientX || e.touches[0].clientX,
        y: e.clientY || e.touches[0].clientY,
      };

      wave.style.cursor = 'grabbing';
      wave.style.userSelect = 'none';

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
      document.addEventListener('touchmove', mouseMoveHandler);
      document.addEventListener('touchend', mouseUpHandler);
    };

    const mouseMoveHandler = (e: any) => {
      if (e.ctrlKey) return;
      const dx = (e.clientX || e.touches[0].clientX) - this.mousePosition.x;
      const dy = (e.clientY || e.touches[0].clientY) - this.mousePosition.y;
      const scrollTop = this.mousePosition.top - dy;
      const scrollLeft = this.mousePosition.left - dx;
      wave.scrollTop = scrollTop;
      wave.scrollLeft = scrollLeft;
    };

    const mouseUpHandler = (e: any) => {
      wave.style.cursor = 'grab';
      wave.style.removeProperty('user-select');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
      document.removeEventListener('touchmove', mouseMoveHandler);
      document.removeEventListener('touchend', mouseUpHandler);
    };

    wave.addEventListener("touchstart", mouseDownHandler);
    wave.addEventListener("mousedown", mouseDownHandler);
  }

  initializeWaveform() {
    this.wavePlugins = {
      cursor: CursorPlugin.create({
        showTime: true,
        opacity: "1",
        customShowTimeStyle: {
          'background-color': '#000',
          color: '#fff',
          padding: '2px',
          'font-size': '10px',
        }
      }),
      timeline: TimelinePlugin.create({
        container: "#" + this.timelineId,
        primaryColor: "black",
        primaryFontColor: "black",
        secondaryFontColor: "black",
        fontSize: 12
      })
    };
    this.waveInstance = WaveSurfer.create({
      container: '#' + this.waveformId,
      waveColor: 'black',
      progressColor: 'black',
      scrollParent: true,
      backend: "MediaElementWebAudio",
      height: 110,
      partialRender: false,
      responsive: true,
      splitChannels: false,
      hideScrollbar: true,
      //barWidth: 2,
      //barRadius: 2,
      //barHeight: 0.5,
      //barGap: 1,
      autoCenter: true,
      plugins: Object.values(this.wavePlugins)
    });

    this.block.tileItem.file.arrayBuffer().then((arrayBuffer) => {
      const blob = new Blob([new Uint8Array(arrayBuffer)], { type: this.block.tileItem.file.type });
      this.audioBuffer = arrayBuffer;
      this.waveInstance.load(new Audio(URL.createObjectURL(blob)));
    });

    this.waveInstance.on("ready", () => {
      this.enableDragScroll();
      this.loadBlockEvent.emit({ block: this.block, waveInstance: this.waveInstance })
    })

    this.waveInstance.on("error", (data) => {
      if (!this.isInError) {
        this.isInError = true;
        this.loadBlockEvent.emit({ block: this.block, waveInstance: this.waveInstance })
        this.async.openAlert("Warning", "There was an error decoding " + this.block.tileItem.file.name,
          (result) => {
            this.deleteBlockRequest({} as Event, this.block);
          })
      }
    })
  }

  zoomIn() {
    this.waveInstance.zoom(20);
  }

  zoomOut() {
    this.waveInstance.zoom(0);
  }

  getTime(duration: any) {
    if (duration !== undefined && !isNaN(duration)) {
      var date = new Date(0);
      date.setSeconds(duration);
      var timeString = date.toISOString().substring(11, 19);
      return timeString;
    }
    return 0;
  }

  preview() {
    let buffer = new ArrayBuffer(this.audioBuffer.byteLength);
    new Uint8Array(buffer).set(new Uint8Array(this.audioBuffer));
    AudioUtils.arrayBufferToAudioBuffer(buffer)
      .then((audioBuffer: AudioBuffer) => {
        const slicedBuffer = AudioUtils.sliceAudioBuffer(audioBuffer, 0, Math.min(audioBuffer.duration * 1000, 10000)) as AudioBuffer;
        const wav = AudioUtils.audioBufferToWav(slicedBuffer, {});
        return wav;
      })
      .then((arrayBuffer: ArrayBuffer) => {
        const blob = new Blob([new Uint8Array(arrayBuffer)], { type: this.block.tileItem.file.type })
        const file = new File([blob], "PREVIEW_" + this.block.tileItem.file.name, { type: this.block.tileItem.file.type });
        this.previewBlockEvent.emit({ block: this.block, file: file });
      });
  }

  openInfoBlock() {
    this.openInfoBlockEvent.emit({ data: { block: this.block, toMenuItems: this.toMenuItems } })
  }
}
